import FingerprintJS from '@fingerprintjs/fingerprintjs';

const getFingerprintUser = async () => {
  // Get the (browser) visitor identifier:
  const fp = await FingerprintJS.load();
  return fp.get();
};

export default getFingerprintUser;
